export default __webpack_public_path__ + "static/media/birthday.4fe435b8.svg";